import { render, staticRenderFns } from "./SalesAgentList.vue?vue&type=template&id=5270ff20"
import script from "./SalesAgentList.vue?vue&type=script&lang=js"
export * from "./SalesAgentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports